import request from '../utils/request';

export function getUserInit(){
    return request({
        url: "/wxmanager/user/userInit",
        method:'post',
    });
}
export function postSaveMobile (data){
    return request({
        url: "/wxmanager/user/userInfo",
        method:'post',
        data,
    });
}